/**
 * NOTE: This is generated file any changes to it can be overwritten at some point
 */
import React from 'react';

import { createSvgIcon } from '../utils';

const QuizIcon = /*#__PURE__*/ createSvgIcon(
  'QuizIcon',
  {
    ltr: {
      large: ({ id }) => (
        <>
          <path
            d="M3.5 17c-.413 0-.766-.147-1.06-.44A1.445 1.445 0 012 15.5v-11c0-.412.147-.766.44-1.06.294-.293.647-.44 1.06-.44h13c.413 0 .766.147 1.06.44.293.294.44.648.44 1.06v11c0 .412-.147.766-.44 1.06-.294.293-.647.44-1.06.44h-13zm0-1.5h13v-11h-13v11zm4.146-1.48c.212 0 .39-.07.534-.213a.72.72 0 00.216-.532.734.734 0 00-.216-.535.72.72 0 00-.534-.22h-2.5a.728.728 0 00-.535.215.72.72 0 00-.215.532c0 .21.072.39.215.535a.72.72 0 00.535.219h2.5zm4.479-3.645l-.538-.544a.67.67 0 00-.52-.216.8.8 0 00-.535.24.745.745 0 00.006 1.058l1.07 1.07c.15.15.324.225.52.225.198 0 .37-.076.518-.229l2.5-2.5a.73.73 0 000-1.063.733.733 0 00-1.063 0l-1.958 1.959zm-4.48.375c.213 0 .391-.072.535-.214a.72.72 0 00.216-.532.734.734 0 00-.216-.535.72.72 0 00-.534-.219h-2.5a.728.728 0 00-.535.214.72.72 0 00-.215.532c0 .21.072.39.215.535a.72.72 0 00.535.219h2.5zm0-3.25c.213 0 .391-.071.535-.214a.72.72 0 00.216-.532.734.734 0 00-.216-.535A.72.72 0 007.646 6h-2.5a.728.728 0 00-.535.214.72.72 0 00-.215.532c0 .21.072.39.215.535a.72.72 0 00.535.219h2.5z"
            fill="currentColor"
          />
        </>
      ),
    },
  },
  false
);

export default QuizIcon;
